import { SortDescriptor } from "react-aria-components";

import { MODULE_VERSION_TEST_CASES_COLUMN_ID } from "./constants";
import { ModuleVersionTestCaseRow } from "./types";

export const sortModuleVersionTestCases = (
  testCases: ModuleVersionTestCaseRow[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return testCases;
  }

  const direction = sortDescriptor.direction === "ascending" ? 1 : -1;
  const column = sortDescriptor.column as MODULE_VERSION_TEST_CASES_COLUMN_ID;

  return [...testCases].sort((a, b) => {
    if (column === MODULE_VERSION_TEST_CASES_COLUMN_ID.STARTED_AT) {
      return (a.createdAt - b.createdAt) * direction;
    }

    let valueA = "";
    let valueB = "";

    switch (column) {
      case MODULE_VERSION_TEST_CASES_COLUMN_ID.STATUS:
        valueA = a.state;
        valueB = b.state;
        break;
      case MODULE_VERSION_TEST_CASES_COLUMN_ID.NAME:
        valueA = a.title;
        valueB = b.title;
        break;
      case MODULE_VERSION_TEST_CASES_COLUMN_ID.COMMIT:
      case MODULE_VERSION_TEST_CASES_COLUMN_ID.DROPDOWN:
        break;
    }

    return valueA.localeCompare(valueB, undefined, { numeric: true }) * direction;
  });
};
